import { Components } from 'react-markdown';
import { CustomAnchor } from './CustomAnchor';
import { CustomParagraph } from './CustomParagraph';
import { CustomUnorderedList } from './CustomUnorderedList';

/**
 * Custom mappings for rendering markdown
 */
export const COMPONENTS: Components = {
  a: CustomAnchor,
  p: CustomParagraph,
  ul: CustomUnorderedList,
};
